import { FunctionComponent, SVGProps } from "react";
import { Box, BoxProps } from "@mui/material";
import CarIcon from "@icons/myicons/contract/car.svg?react";
import LeisureIcon from "@icons/myicons/contract/leisure.svg?react";
import CoinsGrowthIcon from "@icons/myicons/coins-growth.svg?react";
import HomeIcon from "@icons/myicons/home-house.svg?react";
import TargetIcon from "@icons/myicons/target-arrow.svg?react";
import TravelIcon from "@icons/myicons/travel.svg?react";

/** The Material Design Icons names v1 stores, so both UIs show the same icon */
export type GoalIconKey =
  | "beach"
  | "home-outline"
  | "finance"
  | "car"
  | "airplane-takeoff"
  | "bullseye";

export const GOAL_ICON_KEYS: GoalIconKey[] = [
  "beach",
  "home-outline",
  "finance",
  "car",
  "airplane-takeoff",
  "bullseye",
];

const icons: Record<GoalIconKey, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  beach: LeisureIcon,
  "home-outline": HomeIcon,
  finance: CoinsGrowthIcon,
  car: CarIcon,
  "airplane-takeoff": TravelIcon,
  bullseye: TargetIcon,
};

export const toGoalIconKey = (icon?: string): GoalIconKey =>
  GOAL_ICON_KEYS.find((key) => key === icon) ?? "finance";

interface Props {
  icon?: string;
  size?: number;
}

export const GoalIcon = ({ icon, size = 24 }: Props) => {
  const Icon = icons[toGoalIconKey(icon)];
  return <Icon width={size} height={size} aria-hidden />;
};

export const GoalIconTile = ({
  icon,
  size = 40,
  ...rest
}: Props & Omit<BoxProps, "children">) => (
  <Box
    flex={`0 0 ${size}px`}
    width={size}
    height={size}
    borderRadius={1}
    bgcolor="background.selected"
    color="icon.active"
    display="flex"
    alignItems="center"
    justifyContent="center"
    {...rest}
  >
    <GoalIcon icon={icon} size={Math.round(size * 0.6)} />
  </Box>
);
